module.exports = __webpack_public_path__ + "media/images/icons/filled/behance-circle-6016d27216e639f148bc3779c1cd2202.svg";